<template>
    <svg viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.1895 13.25H3V11.75H16.5V13.25H12.3105L14.7428 15.6823L13.6823 16.7428L10.5 13.5605V15.5H9V13.5605L5.81775 16.7428L4.75725 15.6823L7.1895 13.25ZM4.5 2.75H15C15.1989 2.75 15.3897 2.82902 15.5303 2.96967C15.671 3.11032 15.75 3.30109 15.75 3.5V11H3.75V3.5C3.75 3.30109 3.82902 3.11032 3.96967 2.96967C4.11032 2.82902 4.30109 2.75 4.5 2.75ZM5.25 4.25V9.5H14.25V4.25H5.25Z"
            fill="currentColor"/>
    </svg>
</template>
